module.exports = __webpack_public_path__ + "img/Menu-14.c4af4f41.webp";